/*
 *   File : tax-details.js
 *   Author URI : https://mt-user.com
 *   Description :  Component will allow the customer to submit TAX details.
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect, useRef, useState } from "react"
import APIService from "../../../../Service/api-service";
import { CustomSelectBox, CustomTextInput, RadioGroup } from "../../../../Component/Form-elements";
import { Icon } from "../../../../Component/Icon";
import { GradientButton } from "../../../../Component/CTA";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { _convertToLabelIdArray } from "../../../../Helper";
import Store from "../../../../Store";
import { DarkModeContext } from "../../../../Context/dark-mode-context";
import { useContext } from "react";


const RADIO_DATA = [
    {
        label: "Yes",
        id: 1
    },
    {
        label: "No",
        id: 2
    }
]

const REASON_DATA = [
    {
        label: "The country where the Account Holder is liable to pay tax does not issue TIN to its residents.",
        id: 1
    },
    {
        label: "No TIN required [Select this reason only if the authorities of the respective country of tax residence do not require the TIN to be collected]",
        id: 2
    },
    {
        label: "Others",
        id: 3
    }
]
const NRITaxDetailsPage = (props) => {
    const DECLARATION_DATA = useSelector(state => state.generalData.KYC_PROGRESS_DATA.nri_info);
    console.log('DECLARATION_DATA', DECLARATION_DATA);

    const { darkMode } = useContext(DarkModeContext);
    const GENERAL_DATA = useSelector(state => state.generalData.GENERAL_DATA);
    const detailsRef = useRef([]);

    const [isAccepted, setIsAccepted] = useState(false);
    const [apiLoader, setApiLoader] = useState(false);
    const [payTax, setPayTax] = useState(RADIO_DATA[0].id);
    console.log('payTax', payTax);
    console.log('isAccepted', isAccepted);

    console.log('GENERAL_DATA', GENERAL_DATA);


    const [politicallyExposed, setPoliticallyExposed] = useState(2);
    const [tinUnavailableFilter, setTinUnavailableFilter] = useState(_convertToLabelIdArray(GENERAL_DATA.tin_unavailable_reason) ?? []);


    const [taxDetails, setTaxDetails] = useState([{
        tax_resident: RADIO_DATA[0].id,
        country: null,
        country_error: '',
        tin: RADIO_DATA[0].id,
        tin_number: "",
        tin_number_error: "",
        other_reason: "",
        other_reason_err: "",
        reason: tinUnavailableFilter[0].id
    }]);

    console.log('taxDetails', taxDetails);

    const [countryOption, setCountryOptions] = useState([]);

    useEffect(() => {
        _getCountries();
    }, []);

    useEffect(() => {
        if (DECLARATION_DATA !== undefined) {
            setPayTax(DECLARATION_DATA?.tax_payer_other_country === true ? 1 : 2);
            setPoliticallyExposed(DECLARATION_DATA?.politically_exposed === true ? 1 : 2);
            setIsAccepted(DECLARATION_DATA.terms_and_condition);
            const tax_residencies = DECLARATION_DATA?.tax_residencies;
            if (DECLARATION_DATA?.tax_payer_other_country === true && tax_residencies.length > 0) {
                const tax_details = tax_residencies.map((item) => {
                    return {
                        country: item.tax_residency_country_id ? { label: item.tax_country, value: item.tax_residency_country_id } : null,
                        country_error: '',
                        tin: item.has_tin === true ? 1 : 2,
                        tin_number: item.tax_number ?? "",
                        tin_number_error: "",
                        other_reason: item.tin_unavailable_reason_id === 252 ? item.tin_unavailable_reason_text ?? "" : "",
                        other_reason_err: "",
                        reason: item.tin_unavailable_reason_id ?? tinUnavailableFilter[0].id,
                        tax_resident: DECLARATION_DATA.tax_payer_other_country === true ? 1 : 2,
                    }
                })
                console.log('taken_tax', tax_details)
                setTaxDetails(tax_details);
            }
        }
    }, [DECLARATION_DATA]);

    // const _handleRadioFields = (type) => {
    //     switch (type) {
    //         case 1:
    //             setPayTax(!payTax)
    //             break;
    //         case 2:
    //             setPoliticallyExposed(!politicallyExposed);
    //             break;

    //         default: break;
    //     }
    // }

    // API - get countries
    const _getCountries = () => {
        const url = "general/countries";

        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                const countries = response.data.map((item) => {
                    return ({
                        label: item.name,
                        value: item.country_id
                    })
                })
                setCountryOptions(countries);

            }
        })
    };

    function _handleInputFields(value, key, index, error) {
        const tax_details = [...taxDetails];
        tax_details[index][key] = value;
        if (error) {
            tax_details[index][error] = "";
        }
        setTaxDetails(tax_details);
        console.log('tax_details', tax_details);
    }

    function _handleAddResidency() {
        const tax_details = [...taxDetails];
        tax_details.push({
            tax_resident: RADIO_DATA[0].id,
            country: null,
            country_error: '',
            tin: RADIO_DATA[0].id,
            tin_number: "",
            tin_number_error: "",
            other_reason: "",
            other_reason_err: "",
            reason: REASON_DATA[0].id
        });
        setTaxDetails(tax_details);
    }

    function _handleDeleteResidency(index) {
        const tax_details = [...taxDetails];
        tax_details.splice(index, 1);
        setTaxDetails(tax_details);
    }

    function _submitDetails() {
        const tax_details = [...taxDetails];
        let valid = true;

        if (payTax === 1) {
            if (isAccepted === false || isAccepted === null) {
                valid = false;
                toast.dismiss();
                toast.error("All declaration must be selected to continue with KYC flow", {
                    type: "error",
                });
                return;
            }

            tax_details.forEach((element, index) => {
                if (element.tax_resident === 1) {
                    if (element.country === null) {
                        valid = false;
                        detailsRef.current[index]?.scrollIntoView({
                            behavior: "smooth",
                            block: "end",
                            inline: "nearest",
                        });

                        element.country_error = "Country of tax residency is required"
                    }
                    if (element.tin === 1 && element.tin_number === "") {
                        valid = false;
                        detailsRef.current[index]?.scrollIntoView({
                            behavior: "smooth",
                            block: "end",
                            inline: "nearest",
                        });

                        element.tin_number_error = "Tin number is required"
                    }


                    if (element.tin === 2 && element.reason === 252 && element.other_reason.trim().length === 0) {
                        valid = false;
                        detailsRef.current[index]?.scrollIntoView({
                            behavior: "smooth",
                            block: "end",
                            inline: "nearest",
                        });

                        element.other_reason_err = "Other reason is required"
                    }

                }
            })
        }

        if (payTax === 2) {
            if (isAccepted === false || isAccepted === null) {
                valid = false;
                toast.dismiss();
                toast.error("All declaration must be selected to continue with KYC flow", {
                    type: "error",
                });
            }

        }

        if (valid === true) {
            _submitTaxDetails();
        }
        setTaxDetails(tax_details);
    }

    // API - submit tax details
    const _submitTaxDetails = () => {
        setApiLoader(true);
        const url = "kyc/declaration";

        const tax_details = taxDetails.map((item) => {
            return {
                tax_residency_country_id: item?.country?.value,
                has_tin: item.tin === 1 ? true : false,
                tax_number: item.tin === 1 ? item.tin_number : null,
                tin_unavailable_reason_id: item.tin === 2 ? item.reason : null,
                tin_unavailable_reason_text: item.tin === 2 && item.reason === 253 ? item.other_reason : null
            }
        });

        const payload = {
            tax_payer_in_india: payTax === 2 ? true : false,
            politically_exposed: politicallyExposed === 1,
            terms_and_condition: isAccepted,
            tax_residencies: payTax === 1 ? tax_details : []
        }


        APIService(true, url, payload).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                Store.dispatch({
                    type: 'KYC_PROGRESS',
                    payload: response.kyc_data
                });
                props.updateProgress(response.kyc_data.is_review ? 10 : 7, "NRI")
                toast.success("Declaration submitted successfully");
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
            setApiLoader(false);
        });
    }

    return (
        <div>
            <p className="color-black e-poppins e-poppins-bold e-font-24 mb-0">FATCA & Tax details</p>
            <p className="color-outer-space e-poppins-regular e-font-16 line-height-24px mb-0 pt-2" >Enter your TIN and tax-related information.</p>
            <p className="color-outer-space e-poppins-medium e-font-18-sm-16 line-height-24px mb-0 margin-32px-top" >Add your tax residency information</p>

            <div className=" gap-8px mt-sm-3 mt-5 cursor-pointer w-fit-content">
                <p className="color-black e-poppins-regular e-font-sm-16-14 line-height-24px mb-0">Are you a politically exposed person  </p>
                <RadioGroup data={RADIO_DATA}
                    className={`gap-16px mt-2`}
                    type={1}
                    id={politicallyExposed}
                    radioItem="w-max-content"
                    iconClassName="me-2"
                    radioHandler={(id) => setPoliticallyExposed(id)} />
            </div>

            <div className="mt-3">
                <p className="color-black e-poppins-regular e-font-18-sm-16 mt-4 mb-0"> Are you a tax resident in any country other than India? </p>

                <RadioGroup data={RADIO_DATA}
                    className={`gap-16px mt-2`}
                    type={1}
                    id={payTax}
                    radioItem="w-max-content"
                    iconClassName="me-2"
                    radioHandler={(id) => setPayTax(id)} />
            </div>
            {
                payTax === 1 &&
                (taxDetails.map((item, index) => {
                    return (
                        <div key={index} ref={(el) => (detailsRef.current[index] = el)}>
                            <div className="row align-items-center">
                                <div className="col-lg-4 col-sm-6 col-12 pt-4 mt-2">
                                    <CustomSelectBox value={item.country}
                                        label="Country"
                                        postfix="*"
                                        isSearchable={true}
                                        error={item.country_error}
                                        options={countryOption}
                                        onSelectChange={(e) => {
                                            _handleInputFields(e, "country", index, "country_error")
                                        }} />
                                </div>
                                {taxDetails.length > 1 && <div className="col-1 pt-4">
                                    <Icon icon={"delete-red"}
                                        size={24}
                                        className='cursor-pointer'
                                        onClick={() => _handleDeleteResidency(index)} />
                                </div>}
                            </div>

                            <p className="color-black e-poppins-medium e-font-18-sm-16 mt-4">Do you have a TIN or functional equivalent number for this country?</p>
                            <RadioGroup data={RADIO_DATA}
                                className={`gap-16px mt-4`}
                                type={1}
                                id={item.tin}
                                radioItem="w-max-content"
                                iconClassName="me-2"
                                radioHandler={(id) => _handleInputFields(id, "tin", index)} />
                            {
                                item.tin === 1 ?
                                    <div className="col-lg-4 col-sm-6 col-12 pt-4 mt-2">
                                        <CustomTextInput value={item.tin_number}
                                            label="TIN or functional equivalent number"
                                            postfix="*"
                                            id={`tin_number_${index}`}
                                            error={item.tin_number_error}
                                            handleChange={(e) => {
                                                _handleInputFields(e, "tin_number", index, "tin_number_error")
                                            }} />
                                    </div>
                                    :
                                    <>
                                        <p className="color-black e-poppins-medium e-font-18-sm-16 mt-4 pt-2">Choose the reason for not having a TIN</p>
                                        <RadioGroup data={tinUnavailableFilter}
                                            className={`gap-16px mt-4`}
                                            type={1}
                                            id={item.reason}
                                            iconClassName="me-2"
                                            radioHandler={(id) => _handleInputFields(id, "reason", index)} />
                                        {item.reason === 252 && <div className="col-lg-4 col-sm-6 col-12 pt-4 mt-2">
                                            <CustomTextInput value={item.other_reason}
                                                label="Specify the reason"
                                                postfix="*"
                                                id={`other_reason_${index}`}
                                                error={item.other_reason_err}
                                                handleChange={(e) => {
                                                    _handleInputFields(e, "other_reason", index, "other_reason_err")
                                                }} />
                                        </div>}
                                    </>
                            }
                        </div>
                    )
                }))
            }
            {payTax === 1 && <p className="color-deep-blue e-poppins-medium cursor-pointer e-font-16 line-height-16px margin-32px-top mb-0" onClick={_handleAddResidency}>
                <Icon icon="add-circle1"
                    size={24}
                    className='me-2' />
                Add Another Tax Residency
            </p>}
            <div className={`col-md-8 d-flex align-items-start gap-2  margin-40px-top`}>
                <span>
                    <Icon icon={isAccepted === true ? "cart-selected" : 'cart-unselected'}
                        size={24}
                        className='cursor-pointer'
                        onClick={() => setIsAccepted(!isAccepted)} />
                </span>
                <span className={`${darkMode ? 'color-white' : 'color-text-black '} e-poppins-regular e-font-16 line-height-24px`}>
                    I acknowledge that the information provided is true and correct to the best of my knowledge.
                    I authorize the Mutual Fund, its intermediaries, and authorized agencies to disclose and share
                    this information with regulatory authorities as required. I understand that providing false or
                    misleading information may result in penalties or account action. I also confirm that I have
                    read and accepted the FATCA & CRS Terms and Conditions.
                    <br /><br />
                    By pressing continue, you acknowledge and confirm that the information provided by you
                    is true and correct.
                </span>
            </div>
            <GradientButton label="Continue"
                disabled={apiLoader}
                loading={apiLoader}
                className='margin-40px-top padding-12px-tb px-4'
                handleClick={_submitDetails} />

        </div>
    )
}
export default NRITaxDetailsPage